import React from 'react';
import Label from "../../UI/Label";
import { arrowWidth, trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackFBlue = ({ state, workState, onLabelClick }) => (
	<g id="TrackFBlue"
		 transform="translate(1875.000000, 638.000000)"
		 className="track"
	>
		<line x1="4.31922385" y1="8.50200936" x2="36.0237943" y2="16.7748815" id="line"
					stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
					strokeWidth={tracksWidth}
					strokeLinecap="round"
		/>

		<TrackArrow
			transform="translate(6.905151, 9.113994) rotate(-341.000000) translate(-6.905151, -9.113994) "
			points="10.905151 17.113994 2.90515102 9.11399399 10.905151 1.11399399"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackFBlue')}
			coords="4.000000, 17.000000"
			text="F"
			textCoordsX="9.0"
			textCoordsY="17.5"
			size="small"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>

);

TrackFBlue.propTypes = trackPropTypes;

export default TrackFBlue;
